<div class="cart-total {{classCustom}}" (click)="_onClick()">
    <div class="content">
        <div class="box-qtd">
            <i class="fa-solid fa-cart-shopping"></i>
            <span class="qtd">
                <span>{{qtd}}</span>
            </span> 
        </div> 
    </div>   
</div>    
